var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "# icons / check 3 gradient 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ui",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-08-Inventory-ADD-7-validate-success",
    transform: "translate(-752.000000, -497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basic-info",
    transform: "translate(174.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(558.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#-icons-/-error",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "boundbox",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7005303,14.7470105 L35.1102276,29.9472908 C35.6916229,30.8864677 35.4015835,32.119135 34.4624066,32.7005303 C34.1461741,32.8962932 33.7816195,33 33.4096973,33 L14.5903027,33 C13.4857332,33 12.5903027,32.1045695 12.5903027,31 C12.5903027,30.6280779 12.6940095,30.2635232 12.8897724,29.9472908 L22.2994697,14.7470105 C22.880865,13.8078335 24.1135323,13.5177942 25.0527092,14.0991894 C25.3158658,14.2620959 25.5376238,14.4838539 25.7005303,14.7470105 Z M24.3410405,16.0564345 C24.3080647,16.0026319 24.2628274,15.9573946 24.2090248,15.9244188 C24.0206734,15.8089776 23.7744007,15.868083 23.6589595,16.0564345 L14.8732733,30.3909752 C14.8347191,30.4538793 14.8143138,30.5262209 14.8143138,30.6 C14.8143138,30.8209139 14.9933999,31 15.2143138,31 L32.7856862,31 C32.8594653,31 32.9318069,30.9795946 32.994711,30.9410405 C33.1830625,30.8255993 33.2421679,30.5793266 33.1267267,30.3909752 L24.3410405,16.0564345 Z M23.272,26.696 L23.272,20.6 L24.916,20.6 L24.916,26.696 L23.272,26.696 Z M24.1,29.144 C23.56,29.144 23.2,28.784 23.2,28.244 C23.2,27.704 23.56,27.344 24.1,27.344 C24.64,27.344 25,27.704 25,28.244 C25,28.784 24.64,29.144 24.1,29.144 Z",
    id: "Combined-Shape",
    fill: "#F33F8F",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPink);
export default __webpack_public_path__ + "static/media/warning_pink.2415557a93dbcdca9658cdb177f565cb.svg";
export { ForwardRef as ReactComponent };